// Influencers Slider - Swiper initialization
document.addEventListener('DOMContentLoaded', function() {
  
  // Check for reduced motion preference (ADA accessibility)
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // Get settings from section
  const sectionElement = document.querySelector('.influencers-slider');
  const sliderAutoplay = sectionElement && sectionElement.dataset.sliderAutoplay === 'true';
  const sliderDelay = sectionElement ? parseInt(sectionElement.dataset.sliderDelay) * 1000 : 5000;
  
  // Configure autoplay for swiper
  const swiperAutoplay = sliderAutoplay && !prefersReducedMotion ? {
    delay: sliderDelay,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  } : false;
  
  // Initialize Swiper - Manual slider by default, no auto-advance
  const influencersSwiper = new Swiper('.influencers-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: false,
    loop: true,
    grabCursor: true,
    speed: prefersReducedMotion ? 0 : 600, // Slow speed for ADA, instant if reduced motion
    autoplay: swiperAutoplay,
    
    // Navigation arrows
    navigation: {
      nextEl: '.influencers-slider__nav-btn--next',
      prevEl: '.influencers-slider__nav-btn--prev',
    },
    
    // Breakpoints for responsive slidesPerView
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 40,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 50,
        centeredSlides: false,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 60,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 'auto',
        spaceBetween: 60,
        centeredSlides: false,
      }
    },
    
    // Keyboard navigation for accessibility
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    
    // A11y support
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
    },
  });

  // ===== VIDEO BEHAVIOR =====
  // Autoplay when in viewport, pause when out
  // Respect prefers-reduced-motion
  
  const videoCards = document.querySelectorAll('.influencers-slider__card');
  
  // Intersection Observer for viewport detection
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('.influencers-slider__video');
      const card = entry.target;

      if (!video) return;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        // Video is in viewport (50% visible) - autoplay unless reduced motion
        if (!prefersReducedMotion) {
          video.play().catch(() => {
            // Autoplay was prevented, that's okay
          });
          card.classList.add('is-playing');
        }
      } else {
        // Video is out of viewport - pause
        video.pause();
        card.classList.remove('is-playing');
      }
    });
  }, {
    threshold: [0.5], // Trigger when 50% visible
    rootMargin: '0px'
  });
  
  // Observe all video cards
  videoCards.forEach(card => {
    videoObserver.observe(card);
  });

  // Manual Play/Pause button functionality
  const playButtons = document.querySelectorAll('.influencers-slider__play-btn');

  playButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const card = this.closest('.influencers-slider__card');
      const video = card.querySelector('.influencers-slider__video');

      if (!video) return;

      if (video.paused) {
        video.play().catch(() => {});
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });
  });

  // Pause all videos when slide changes (swipe or arrow click)
  influencersSwiper.on('slideChange', function() {
    if (prefersReducedMotion) {
      // If reduced motion, pause all on slide change
      document.querySelectorAll('.influencers-slider__video').forEach(video => {
        video.pause();
        video.closest('.influencers-slider__card').classList.remove('is-playing');
      });
    }
  });

  // Section-level Intersection Observer
  // Pause all videos when section leaves viewport
  const sliderSection = document.querySelector('.influencers-slider');
  
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        // Section is out of viewport - pause all videos
        document.querySelectorAll('.influencers-slider__video').forEach(video => {
          video.pause();
          video.closest('.influencers-slider__card').classList.remove('is-playing');
        });
      }
    });
  }, {
    threshold: 0
  });
  
  if (sliderSection) {
    sectionObserver.observe(sliderSection);
  }

  // Listen for reduced motion preference changes
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
    if (e.matches) {
      // User enabled reduced motion - pause all videos
      document.querySelectorAll('.influencers-slider__video').forEach(video => {
        video.pause();
        video.closest('.influencers-slider__card').classList.remove('is-playing');
      });
    }
  });
});
